import { useCallback, useState } from "react";

import { UploadedFile, uploadFiles } from "@/api/rest/services/uploadService";

/** Upload state for one form: progress while sending (0..1, null when idle) and the last error to show. */
export const useFileUpload = () => {
  const [progress, setProgress] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  // null when the upload failed; the error is then set.
  const upload = useCallback(async (files: File[]): Promise<UploadedFile[] | null> => {
    setError(null);
    if (files.length === 0) {
      return [];
    }
    setProgress(0);
    const result = await uploadFiles(files, setProgress);
    setProgress(null);
    if (!result.success) {
      setError(result.message);
      return null;
    }
    return result.result;
  }, []);

  return { upload, progress, error, setError };
};
